import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { MessageService } from "../../services/message.service";
import { FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { PiService } from "../../services/pi.service";

@Component({
  selector: 'app-linked-pi',
  templateUrl: './linked-pi.component.html',
  styleUrls: ['./linked-pi.component.scss']
})
export class LinkedPiComponent {
  @Input() inputString: any;
  @Input() inputType: any;
  @Input() editable = true;
  @Output() refereshParentData = new EventEmitter<string>();
  @Input() PIdata: any;
  @Input() label : string;
  @Input() required: boolean = false;
  oldData: any;
  pi: any;
  selectedPI: any = [];

  myControl = new FormControl();
  filteredOptions: Observable<string[]>;

  editMode = false;

  constructor(
    private readonly cookieService: CookieService,
    private readonly messageService: MessageService,
    private readonly piService: PiService
  ) {}

  ngAfterViewInit() {
    this.getLinkedPIData();

    if (!this.cookieService.get("pi")) {
      const myDate: Date = new Date();
      myDate.setSeconds(myDate.getSeconds() + 10);

      this.cookieService.set("pi", "true", { expires: myDate });
      this.getAllPI();
    }
  }

  async getLinkedPIData() {
    this.messageService.getLinkedPIData().subscribe((res: any) => {
      if (res.length > 0) {
        this.selectedPI = [];
        this.pi = res;
        if (this.PIdata) {
          this.PIdata.forEach((element: any) => {
            this.pi.forEach((elm: any) => {
              if (elm.id === element?.id) {
                this.selectedPI.push(elm);
              }
            });
          });
        }
        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(""),
          map((value) => this._filter(value))
        );
      }
    });
  }

  private _filter(value: any): any {
    if (typeof value === "string") {
      const filterValue = value?.toLowerCase();

      const removeSelected = this.pi.filter((el: any) => {
        return !this.selectedPI.includes(el);
      });

      return removeSelected.filter((wg: any) =>
        wg?.name?.toLowerCase().includes(filterValue)
      );
    }
    return [];
  }

  getAllPI() {
    this.piService.getProgramIncrementNames().subscribe((res: any) => {
      this.messageService.setLinkedPIData(res);
    });
  }

  addPI(e: any) {
    this.selectedPI.push(e);
    this.myControl.setValue("");
    this.sendToParent();
  }

  removePI(i: any) {
    this.selectedPI.splice(i, 1);
    this.sendToParent();
  }

  sendToParent() {
    const sel: any = [];
    this.selectedPI.forEach((element: any) => {
      sel.push(element.id);
    });
    this.refereshParentData.emit(sel);
  }

  cancelEdit() {
    this.inputString = this.oldData;
    this.editMode = false;
  }
}
